<div class="relative h-full p-6 overflow-y-auto flex flex-col">
  <span class="text-2xl mb-4">{{ title$ | async | transloco }}</span>
  <span class="text-sm break-words mb-4">{{ description$ | async | transloco }}</span>
  <app-job-dialog-form
    [placeholder]="placeholder$ | async"
    [buttonSubmit]="buttonSubmit$ | async"
    [item]="item$ | async"
    (formSubmit)="onSubmit($event)"
  ></app-job-dialog-form>
</div>
